import {h, Component} from 'preact';

import { LazyTree as AwrabetLazyTree } from '../../awrabet/utils/suggest-tree-filter';

const COLORS = ['#616161', '#D32F2F', '#0288D1', '#689F38', '#512DA8', '#00796B', '#FBC02D', '#E64A19'];

export class LazyTree extends AwrabetLazyTree {
	render({loadChildren, onNodeSelected, firstLevelOpen = false, currentSelection = ''}) {
		const renderNode = (node, parents) => <TreeElement key={node.id}>
			<TreeElementName 
				has-content={!node.loaded || node.sub.length > 0} 
				parents={parents}
				isUser={node.type == 'player'}
				open={node.opened} 
				onClick={e => onNodeSelected && onNodeSelected(node)} 
				onOpen={isOpening => {
					if (isOpening) {
						node.opened = true;
						this.setState(this.state);
						return this.loadNodeChildren(node)
					}
					node.opened = false;
					this.setState(this.state);
				}}
				selected={node.id == currentSelection}
				data-id={node.id}
			>{node.name}</TreeElementName>
			<TreeElementsGroup>
				{node.opened && node.loaded && node.sub.map(node => renderNode(node, parents+1))}
			</TreeElementsGroup>
		</TreeElement>;

		return this.state.root.map(node => renderNode(node, 0));
	}
}

const TreeElementsGroup = ({children}) => <div class="pl-2">{children}</div>;
const TreeElement = ({children}) => <div class="li-element">{children}</div>;

const TreeElementName = ({children, onOpen, onClick, isUser, ...props}) => <div class={"name px-1 hover:bg-gray-200 cursor-pointer whitespace-no-wrap flex"+(props.selected ? ' bg-gray-200' : '')} data-mu-struct-id={props['data-id']}>
	<div class="w-3 mr-2 text-center" onClick={e => props['has-content'] && onOpen(!props['open'])}>
		{isUser 
			? <UserIcon  class="w-3 relative top-1" color={props.parents === undefined ? props.parents : COLORS[props.parents % COLORS.length]} /> 
			: props['has-content'] 
				? (!props['open'] 
					? <PlusIcon  class="w-3 relative top-1.5" color={props.parents === undefined ? props.parents : COLORS[props.parents % COLORS.length]} /> 
					: <MinusIcon class="w-3 relative top-1.5" color={props.parents === undefined ? props.parents : COLORS[props.parents % COLORS.length]} /> )
				: <EmptyIcon class="w-3 relative top-1.5" color={props.parents === undefined ? props.parents : COLORS[props.parents % COLORS.length]} />}
	</div>
	<div class="py-1 flex-1 truncate overflow-hidden" onClick={e => e.target === e.currentTarget ? onClick(e) : null} title={!children ? '' : typeof children == 'string' ? children : children[0]}>{children}</div>
</div>;

const PlusIcon = (props) =>
	<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
		<path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" class=""></path></svg>;

const MinusIcon = (props) => 
	<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="minus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
		<path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" class=""></path></svg>;

const UserIcon = (props) => 
	<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
		<path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" class=""></path></svg>;

const EmptyIcon = (props) => 
	<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class={props.class} style={(props.color ? 'color:'+props.color+';' : '')+props.style}>
		<path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>;

